import {
    ArrowForwardIos,
    ContentCopy,
    Delete,
    RemoveCircle,
    Tag,
  } from "@mui/icons-material";
  import React, { memo } from "react";
  import { useNodeStorage } from "../../../stores/useNodeStorage";
  import { Handle } from "react-flow-renderer";
  
  export default memo(({ data, isConnectable, id }) => {
    const storageItems = useNodeStorage();
    
    return (
      <div
        style={{
          backgroundColor: "#fff1f2",
          padding: "8px",
          borderRadius: "14px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          border: "1px solid #fecdd3",
        }}
      >
        <Handle
          type="target"
          position="left"
          style={{
            background: "#f43f5e",
            width: "14px",
            height: "14px",
            top: "20px",
            left: "-9px",
            border: "2px solid white",
            cursor: "pointer",
          }}
          onConnect={(params) => console.log("handle onConnect", params)}
          isConnectable={isConnectable}
        />

        <div
          style={{
            display: "flex",
            position: "absolute",
            right: 5,
            top: 5,
            cursor: "pointer",
            gap: 6,
          }}
        >
          <ContentCopy
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
            sx={{ width: "12px", height: "12px", color: "#6b7280" }}
          />
          <Delete
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
            sx={{ width: "12px", height: "12px", color: "#6b7280" }}
          />
        </div>

        <div
          style={{
            color: "#111827",
            fontSize: "16px",
            flexDirection: "row",
            display: "flex",
          }}
        >
          <RemoveCircle
            sx={{
              width: "16px",
              height: "16px",
              marginRight: "4px",
              marginTop: "4px",
              color: "#f43f5e",
            }}
          />
          <div style={{ color: "#111827", fontSize: "16px" }}>Remover Tag</div>
        </div>

        <div style={{ color: "#374151", fontSize: "12px", width: 180 }}>
          <div
            style={{
              backgroundColor: "#ffe4e6",
              marginBottom: "3px",
              borderRadius: "8px",
              padding: "8px",
            }}
          >
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              color: "#f43f5e",
            }}>
              <Tag sx={{ width: "14px", height: "14px" }} />
              <span style={{ fontSize: "11px", fontWeight: "500" }}>
                {data?.tag?.name || "Tag não selecionada"}
              </span>
            </div>
            {data?.tag?.name && (
              <div style={{
                fontSize: "10px",
                color: "#9f1239",
                marginTop: "2px",
                fontStyle: "italic",
              }}>
                Remove a tag do contato
              </div>
            )}
          </div>
        </div>

        <Handle
          type="source"
          position="right"
          style={{
            background: "#f43f5e",
            width: "14px",
            height: "14px",
            top: "20px",
            right: "-9px",
            border: "2px solid white",
            cursor: "pointer",
          }}
          isConnectable={isConnectable}
        />
      </div>
    );
  });